import * as React from "react";
const SvgPersonCircle20Px = (props) =>
  React.createElement(
    "svg",
    Object.assign(
      {
        xmlns: "http://www.w3.org/2000/svg",
        width: 18,
        height: 18,
        fill: "black",
        viewBox: "0 0 18 18"
      },
      props
    ),
    React.createElement("path", {
      fill: "current",
      fillRule: "evenodd",
      d: "M9 2a7 7 0 0 0-4.998 11.9A3 3 0 0 1 7 11h4a3 3 0 0 1 2.998 2.9A7 7 0 0 0 9 2Zm3 13.326V14a1 1 0 0 0-1-1H7a1 1 0 0 0-1 1v1.326c.91.432 1.926.674 3 .674s2.09-.242 3-.674ZM0 9a9 9 0 1 1 18 0A9 9 0 0 1 0 9Zm9-3a1 1 0 1 0 0 2 1 1 0 0 0 0-2ZM6 7a3 3 0 1 1 6 0 3 3 0 0 1-6 0Z",
      clipRule: "evenodd"
    })
  );
export default SvgPersonCircle20Px;
